<thehubz-history [resourceId]="assetId" [tableType]="'Asset'"></thehubz-history>
